import { render, staticRenderFns } from "./SolicitudesConfiguracionClasesListado.vue?vue&type=template&id=404f9e26"
import script from "./SolicitudesConfiguracionClasesListado.vue?vue&type=script&lang=js"
export * from "./SolicitudesConfiguracionClasesListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports